export enum ChartTimeUnit {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
}
